import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import $ from 'jquery';

const GLOBAL = require('../../Globals');

class SalarySettings extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			id : '',
			acyear : '',
			dept : '',
			depart : [],
			accyear : [],
			emp : [],
			payhe : [],
			desig : '',
			employee : '',
			payhead : '',
			unit : '',
			ptype : '',
			_message : '',
			alertClass :'',
			_redirect : false,
			 posts: [],
			 salary : []
		}
		this.onChange = this.onChange.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.onClick = this.onClick.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
	}
	
	onClick(e){
		
		document.getElementById("salform").reset();
	}
	
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
		this.getemployee();
		this.getdata();
	}
	
	onSubmit(e){
		e.preventDefault();
		$("#showLoader").show();
		PostData('payroll/addsalarysetting',this.state).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson.status == '1' ){
				this.state = {payhead : '',
					unit : '',};
				this.getdata();
			}
			else{
		
				this.setState({
					_message:'Already Added',
					alertClass:'alert alert-danger'
				});
			}
		});
		// alert('id '+id+'pay '+payhead+' val '+e.target.value);
		console.log(this.state.salary);
	}
	
	/** remove function **/
	handleClick(dd){
		
		this.state.id = dd;
		console.log('id'+this.state.id);
		
		if (window.confirm("Do you want to Delete?")) {
				$("#showLoader").show();
			PostData('payroll/deletesalset',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Salary Settings Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove Salary Settings',
						alertClass:'alert alert-danger'
					});
				}
			});
		}		
	}
	
	onUpdate(dt){
		
		this.state.idd = dt;
		this.setState({_redirect: true});
		
	}
	
	/** this function will be call when page loading **/
	componentWillMount(){
		
		this.getacyear();
		this.getdepartment();
		this.getpayhead();
	}
	
	/** get Academic Year **/
	getacyear(){
		
		GetData('academic/getacyear').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					accyear : responseJson
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear : academic
				});
				$('#year option').eq(1).prop('selected', true).trigger('change');
			}
		});
	}
	
	/** get Department **/
	getdepartment(){
		
		GetData('department/getdepartment').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					depart : responseJson
				});
			}
		});
	}
	
	/** get Employee **/
	getemployee(){
		
		var cs = $("#depart").val();
		$("#showLoader").show();
		GetData('employee/getempbydept/'+cs).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					emp : responseJson
				});
			}
		});
	}
	
	getdata(){
		var emp = $("#employ").val();
		$("#showLoader").show();
		GetData('payroll/getsalset/'+emp).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
	/** get Payhead **/
	getpayhead(){
		$("#showLoader").show();
		GetData('payroll/getpayheadbyannual').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					payhe : responseJson
				});
			}
		});
	}
	
	
  render() {
	
	if(this.state._redirect){
		  
		return (<Redirect to={'/employee/payroll/editsalarysetting/' + this.state.idd} />);

	}
	
	  /** set value to payhead type **/	
	this.phtype = [
		{value : '', name : 'Select'},
		{value : 'amount', name : 'Amount'},
		{value : 'percentage', name : 'Percentage'}
	];
	
	var dept = this.state.depart;
	var acyear = this.state.accyear;
	var pay = this.state.payhe;
	
	if(this.state.acyear!='' && this.state.dept!='' && this.state.employee!=''){
		
		$("#salset").show();
	}
	else{
		
		$("#salset").hide();
	}
	
	  /** get Employee By Department **/
	$("#depart").change(function(){
		var fr = $(this).val();
		$("#showLoader").show();
		$.get(GLOBAL.BASE_URL+'employee/getempbydept/'+fr,function(o){
			$("#showLoader").hide();
			$("#employ").html('');
			$('#employ')
				.append($("<option></option>")
				.attr("value",'')
				.text(' -Select Employee- ')); 
			$.each(o,function(key,value){			
				   $('#employ')
					.append($("<option></option>")
					.attr("value",value.id)
					.text(value.empname)); 	
										
			});	
			
		},'json');
	
	});
	
	$("#phead").change(function(){
		
		var phead = $(this).val();
		var pf = '12';
		var esi = '1.75';
		var empty = '';
		if(phead == '2'){
			
			$('#ptype option').eq(2).prop('selected', true).trigger('change');
			$("#unit").val(pf);
			$('#ptype').attr("disabled","disabled");
			$('#unit').attr("disabled","disabled");
		}
		else if(phead == '3'){
			
			$('#ptype option').eq(2).prop('selected', true).trigger('change');
			$("#unit").val(esi);
			$('#ptype').attr("disabled","disabled");
			$('#unit').attr("disabled","disabled");
		}
		else{
			
			$('#ptype option').eq(0).prop('selected', true).trigger('change');
			$("#unit").val(empty);
			$('#ptype').removeAttr("disabled");
			$('#unit').removeAttr("disabled");
		}
	})
	   
    return (
		<div className="animated fadeIn">
			<div className={this.state.alertClass}>
				{this.state._message}
			</div>
			<Row>
			  <Col md="12">
				<Card>
				  <form action="" method="post" role="form" id="salform" encType="multipart/form-data" onSubmit={this.onSubmit} >
					<CardHeader>
						<strong>Salary Settings</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						Academic Year : &nbsp;&nbsp;
						<select name="acyear" onChange={this.onChange} required id="year">
							<option value="">Select Academic Year</option>
							{
								acyear.map(function (item) {
									return <option value={item.id }>{item.value}</option>;
								})
							}
						</select>&nbsp;&nbsp;
						Department : &nbsp;&nbsp;
						<select name="dept" onChange={this.onChange} required id="depart">
							<option value="">Select Department</option>
							{
								dept.map(function (item) {
									return <option value={item.id }>{item.department}</option>;
								})
							}
						</select>&nbsp;&nbsp;
						Employee : &nbsp;&nbsp;
						<select name="employee" onChange={this.onChange} required id="employ">
							
						</select>
					</CardHeader>
					<CardBody id="salset">
					 <Row>
					  <Col md="7">
						<Table responsive bordered  id="atttable">
						  <thead>
							<tr>
								<th>S.No</th>
								<th>Payhead</th>
								<th>Type</th>
								<th>Amount</th>
								<th>Manage</th>
							</tr>
						  </thead>
						  <tbody>
							{this.state.posts.map((item,i) =>
						 
								<tr key = {item}>
									<td>{i+1}</td>
									<td>{item.payname}</td>
									<td className="txt-capital">{item.type}</td>
									<td>{item.amount}</td>
									<td>
										<button name="editacyear" className="btn btn-info btn-sm" onClick={() => this.onUpdate(item.id)} ><i className="fa fa-edit"></i></button>
										&nbsp;&nbsp;
										<button name="removesub" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} ><i className="fa fa-remove"></i></button>
									</td>
								</tr>
				  
							 )}
						  </tbody>
						</Table>
					  </Col>
					  <Col md="5">
						<CardHeader>
							<strong>Salary Settings</strong>
						</CardHeader>
						<CardBody>
							<Row>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Payhead <span className="text-danger">*</span></Label>
								  <select name="payhead" onChange={this.onChange} className="form-control" required id="phead">
									<option value="">Select Payhead</option>
									{
										pay.map(function (item) {
											return <option value={item.id }>{item.payheadname}</option>;
										})
									}
								  </select>
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Type <span className="text-danger">*</span></Label>
								  <select name="ptype" className="form-control" onChange={this.onChange} required id="ptype">
									{this.phtype.map((e, key) => {
										return <option key={key} value={e.value}>{e.name}</option>;
									})}	
								 </select>
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Unit <span className="text-danger">*</span></Label>
								  <Input type="text" name="unit" required onChange={this.onChange} id="unit" />
								</FormGroup>
							  </Col>
							</Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
							<Button type="reset" size="sm" color="danger" onClick={this.onClick}><i className="fa fa-ban"></i> Reset</Button>
						</CardFooter>
					  </Col>
					 </Row>
					</CardBody>
				  </form>
				</Card>
			  </Col>
			</Row>
		</div>
	)
  }
}

export default SalarySettings;


// WEBPACK FOOTER //
// ./src/payroll/SalarySettings/SalarySettings.js